// import { StrictMode } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { createRoot } from "react-dom/client";
import "react-sortable-tree/style.css";

import App from "./App.tsx";
import Providers from "./provider.tsx";
import "./styles/index.css";

createRoot(document.getElementById("root")!).render(
  // <StrictMode>
  <Providers>
    <App />
  </Providers>
  // </StrictMode>
);
